/**
 * Cell Component - Individual board cell
 */

import React from 'react';
import Piece from './Piece';

function Cell({
  index,
  value,
  isSelected = false,
  isValidTarget = false,
  isWinning = false,
  isDisabled = false,
  canDragPiece = false,
  isDragging = false,
  isDragTarget = false,
  onClick,
  onPieceDragStart,
}) {
  const handleClick = () => {
    if (isDisabled) return;

    if (onClick) {
      onClick(index);
    }
  };

  const handlePieceDragStart = (clientX, clientY) => {
    if (onPieceDragStart && canDragPiece) {
      onPieceDragStart(index, clientX, clientY);
    }
  };

  const classNames = [
    'stt-cell',
    value && 'stt-cell--occupied',
    value === 'O' && 'stt-cell--o',
    isSelected && 'stt-cell--selected',
    isValidTarget && 'stt-cell--valid-target',
    isDragTarget && 'stt-cell--drag-target',
    isWinning && 'stt-cell--winning',
    isDisabled && 'stt-cell--disabled',
  ].filter(Boolean).join(' ');

  return (
    <div
      className={classNames}
      data-cell-index={index}
      onClick={handleClick}
      role="button"
      tabIndex={isDisabled ? -1 : 0}
      aria-label={`Cell ${index + 1}${value ? `, contains ${value}` : ', empty'}${isValidTarget ? ', valid move' : ''}`}
    >
      {value && (
        <Piece
          type={value}
          isDraggable={canDragPiece}
          isSelected={isSelected}
          isDragging={isDragging}
          onDragStart={handlePieceDragStart}
        />
      )}
    </div>
  );
}

export default Cell;
